import { atom } from "jotai";

import { DiningBookingWizard } from "../../../types";
import {
  DiningBookingWizardDataAtom,
  DiningBookingWizardListOfStepsAtom,
} from "../../stores";

export const updateDiningPartySize = atom(
  null,
  (get, set, groupSize: number) => {
    const diningData = get(DiningBookingWizardDataAtom);
    if (!diningData) {
      //@TODO: this is an error
      return;
    }

    set(DiningBookingWizardDataAtom, {
      ...diningData,
      partySize: groupSize,
    });

    const steps = get(DiningBookingWizardListOfStepsAtom);
    const hasAddKnownPeopleStep = steps.includes("DiningAddKnownPeopleStep");

    const updatedSteps: DiningBookingWizard.DiningBookingWizardStep[] =
      groupSize > 1
        ? hasAddKnownPeopleStep
          ? steps
          : [...steps, "DiningAddKnownPeopleStep"]
        : steps.filter((step) => step !== "DiningAddKnownPeopleStep");

    if (updatedSteps !== steps) {
      set(DiningBookingWizardListOfStepsAtom, updatedSteps);
    }
  }
);
